import React, { useEffect, useState } from 'react'
import { Resource, Admin, combineDataProviders, Loading, CustomRoutes, useTranslate } from 'react-admin'
import { Route } from 'react-router-dom'

import { Dashboard } from './components/pages/dashboard/Dashboard'
import { LoginCustom } from 'src/components/pages/loginPage/LoginCustom'

import authProvider from './authentication/authProvider'
import RuleProvider from './services/RuleProvider'
import PaymentProvider from './services/PaymentProvider'
import B2Provider from './services/B2Provider'
import AuthenticationProvider from './services/AuthenticationProvider'
import getI18nProvider from 'src/languages/i18nProvider'
//Styling and Layout
import { theme } from './themes/theme'
import AppGlobalStyles from './assets/GlobalStyles'
import CssBaseline from '@mui/material/CssBaseline'
import { firstLetterCapitalized } from './helper/firstLetterCapitalized'
import LayoutTopNav from './components/layouts/layoutTopNav'
import { getUserPermissions } from './services/getUserPermission'
import BusinessRuleVersionsList from 'src/components/pages/sales/business-rule/BusinessRuleVersionsList'
import BillingFormConciliations from 'src/components/pages/payment/billing-form/billingFormConciliations'
import BillingFormList from 'src/components/pages/payment/billing-form/billingFormList'
import BillingFormEdit from 'src/components/pages/payment/billing-form/billingFormEdit'
import BusinessRuleVersionShow from 'src/components/pages/sales/business-rule/BusinessRuleVersionShow'
import PaymenRegister from './components/pages/payment/payment/PaymenRegister'
import BillingRegister from './components/pages/payment/billing-form/BillingRegister'
import PaymentList from './components/pages/payment/payment/PaymentList'
import { PaymentProviderContext } from 'src/components/pages/payment/payment/context/PaymentProvider'
import { BillingProviderContext } from 'src/components/pages/payment/billing-form/context/BillingProvider'
import { Payment } from 'src/components/pages/payment/payment/Payment'
import { ItemPayment } from 'src/components/pages/payment/payment/logic/ItemPayment'
import { userServices } from './services/auth/user/user.service'
import MyDevices from './components/pages/authentication/user/MyDevices'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import OperationBff from './services/OperationBff'
import { NotificationCreate } from './components/pages/sales/notification/NotificationCreate'
import {AccountStateList} from './components/pages/administration/account-state'
import { ReportingList } from './components/pages/sales/reporting/ReportingList'
import { ReportingForm } from './components/pages'
import { ReportingProvider } from './components/pages/sales/reporting/logic/ReportingContext'
import { sessionStorageStore } from './SessionStorageStore'

const getCustomRoutes = (entity) => {
  if (entity === 'billingform') {
    return (
      <>
        <Route exact path='/:id/edit' element={<BillingFormEdit />} />
        <Route exact path='/:id/show' element={<BillingFormEdit />} />
        <Route exact path='/' element={<BillingFormList />} />
        <Route exact path='/create' element={<BillingProviderContext>
          <BillingRegister />
        </BillingProviderContext>
        } />
      </>
    )
  }
  if (entity === 'bilingform_conciliation') {
    return (
      <>
        <Route exact path='/' element={<BillingFormConciliations />} />
        <Route exact path='/create' element={<BillingFormConciliations />} />
      </>
    )
  }
  if (entity === 'notification') {
    return (
      <>
        <Route exact path='/create' element={<NotificationCreate />} />
      </>
    )
  }
  if (entity === 'business-rule') {
    return (
      <>
        <Route exact path='/:id/versions' element={<BusinessRuleVersionsList />} />
        <Route exact path='/:id/versions/:id_version/show' element={<BusinessRuleVersionShow />} />
      </>
    )
  }
  if (entity === 'account-state') {
   return (<Route
      exact
      path='/'
      element={
        <AccountStateList/>
      }
    />)
  }
  if (entity === 'reporting') {
   return (
   <>
   <Route
      exact
      path='/'
      element={
        <ReportingProvider>
          <ReportingList/>
        </ReportingProvider>
      }
    />
    <Route
      exact
      path='/create'
      element={
        <ReportingProvider>
          <ReportingForm/>
        </ReportingProvider>
      }
    />
    </>
    )
  }
  if (entity === 'payment-entity') {
    return (
      <>
        <Route
          exact
          path='/'
          element={
            <PaymentProviderContext>
              <PaymenRegister />
            </PaymentProviderContext>
          }
        />
        <Route
          exact
          path='/payment'
          element={
            <PaymentProviderContext>
              <Payment />
            </PaymentProviderContext>
          }
        />
        <Route
          exact
          path='/payment-item'
          element={
            <PaymentProviderContext>
              <ItemPayment />
            </PaymentProviderContext>
          }
        />
        <Route
          exact
          path='/payments'
          element={
            <PaymentProviderContext>
              <PaymentList />
            </PaymentProviderContext>
          }
        />
      </>
    )
  }
}

const wasResolved = (promise, componentName) => {
  if (promise.status === 'rejected') {
    // console.log('resource not found', promise.reason.stack)
    return undefined
  }
  return promise.value[componentName]
}

const getResourcesWithPermissions = async () => {
  let objectWithFileNames = {
    create: '',
    list: '',
    show: '',
    edit: '',
    delete: false,
  }
  let arrayWithResources = []
  let ComponentCreate = null
  let ComponentList = null
  let ComponentShow = null
  let ComponentEdit = null

  let permissionUser = getUserPermissions()

  if (permissionUser?.hasOwnProperty('modules')) {
    for await (const modules of permissionUser?.modules) {
      for await (const permissionResource of modules.permission) {
        if (permissionResource?.entity) {
          // resourceName: get resource name and change to capitalized ex: Currency
          let resourceName = firstLetterCapitalized(permissionResource.entity)
          // resourceNameSplit: if resourceName have "-" ex: Business-Type, remove "-"
          let resourceNameSplit = resourceName.split('-')
          resourceName = resourceNameSplit.map((elem) => firstLetterCapitalized(elem)).join('')
          // assign action if are included in permission, else action will be empty ""
          objectWithFileNames.create = permissionResource.actions.some((action) => action.action === 'create')
            ? resourceName + 'Create'
            : ''
          objectWithFileNames.list = permissionResource.actions.some((action) => action.action === 'menu')
            ? resourceName + 'List'
            : ''
          objectWithFileNames.show = permissionResource.actions.some((action) => action.action === 'show')
            ? resourceName + 'Show'
            : ''
          objectWithFileNames.edit = permissionResource.actions.some((action) => action.action === 'edit')
            ? resourceName + 'Edit'
            : ''
          objectWithFileNames.delete = permissionResource.actions.some((action) => action.action === 'delete')
            ? true
            : false

          objectWithFileNames.revision = permissionResource.actions.some(
            (action) => action.action === 'revision'
          )
            ? true
            : false

          // import resource dinamilly, if user does not have permission
          // then we  import index indirectly, because this import (index) brings us "default" object(default contain all actions but the default is not use)
          // if we don't do this then throw error
          try {
            const promises = [import(`./components/pages`)]
            const results = await Promise.allSettled(promises) // allSettled avoid rejected and continue
            ComponentCreate = wasResolved(results[0], objectWithFileNames.create)
            ComponentList = wasResolved(results[0], objectWithFileNames.list)
            ComponentShow = wasResolved(results[0], objectWithFileNames.show)
            ComponentEdit = wasResolved(results[0], objectWithFileNames.edit)
          } catch (error) {
            throw new Error('resource not valid')
          }
          // if user have permission we access the function, the function name is in objectWithFileNames,
          // if is undefined then we return null
          arrayWithResources.push(
            <Resource
              name={permissionResource.entity}
              create={ComponentCreate || null}
              list={ComponentList || null}
              show={ComponentShow || null}
              edit={ComponentEdit || null}
              options={{ delete: objectWithFileNames.delete, revision: objectWithFileNames.revision }}
            >
              {getCustomRoutes(permissionResource.entity)}
            </Resource>
          )
        }
      }
    }
  }

  return arrayWithResources
}

const servers = {
  rule: ['business-rule', 'rule-type', 'ext-train-marketing-carrier', 'formula-global-variables'],
  auth: [
    'role',
    'application',
    'module',
    'entity',
    'process',
    'user',
    'permission',
    'client',
    'processApplication',
    'my-devices',
  ],
  fast_api_b2: [
    'currency',
    'work-unit',
    'document-type',
    'country',
    'product',
    'business-type',
    'reservation',
    'air-detail',
    'hotel-detail',
    'business-unit',
    'contact',
    'supplier',
    'billing',
    'fiscal-data',
    'type-responsible',
    'tag',
    'product-type',
    'numbering',
    'source',
    'air_tickets',
    'banner-type',
    'banner',
    'landing',
    'userB2',
    'due-date-method',
    'due-date-range',
  ],
  payment: [
    'payment-type',
    'card',
    'financial-entity',
    'cash',
    'company',
    'operation-type',
    'bank',
    'payment-method',
    'payment-entity',
    'commerce-number',
    'gateway',
    'installment',
  ],
  bucket: ['operation'],
  obff: ['operation-bff']
}

const dataProvider = combineDataProviders((resource) => {
  const { auth, fast_api_b2, rule, payment, obff } = servers

  if (auth.includes(resource)) {
    return AuthenticationProvider
  }
  if (fast_api_b2.includes(resource)) {
    return B2Provider
  }
  if (rule.includes(resource)) {
    return RuleProvider
  }
  if (payment.includes(resource)) {
    return PaymentProvider
  }
  if (obff.includes(resource)) {
    return OperationBff
  }
  // throw new Error(`Unknown resource: ${resource}`);
})

function App() {
  const [loading, setLoading] = useState(false)
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'es-AR')
  const translate = useTranslate()

  useEffect(() => {
    ; (async () => {
      let location = window.location.href
      let index = location.indexOf('?')

      if (index > -1) {
        location = location.slice(index)
        const params = new URLSearchParams(location)
        const token = params.get('token')
        if (token) {
          setLoading(true)
          localStorage.clear()
          const response = await userServices.loginByToken(token)
          const fp = await FingerprintJS.load()
          const result = await fp.get()
          response.application.modules.forEach((module) => {
            const permissions = []
            module.permission.forEach((permission) => {
              if (!permissions.find((elem) => elem.entity_id === permission.entity_id)) {
                permissions.push(permission)
              }
            })
            module.permission = permissions
          })
          localStorage.setItem('jwt', response.jwt)
          localStorage.setItem('hash_user', response.user.hashuser)
          localStorage.setItem('application', JSON.stringify(response.application))
          localStorage.setItem('language', response.user.language || language)
          localStorage.setItem(
            'user',
            JSON.stringify({
              ...response.user,
              roles: response.roles,
              dashboard: response?.dashboard,
              user_id: response?.user?.user_id,
              client_id: response?.client_id,
              visitor_id: result?.visitorId,
            })
          )

          params.delete('token')
          location = window.location.href.slice(0, index)
          if (params.size > 0) {
            location += `?${params.toString()}`
          }

          window.location.href = location
          setLoading(false)
        } else {
          setLoading(false)
        }
      } else {
        setLoading(false)
      }
    })()
  }, [])

  useEffect(() => {
    const handleLanguageChange = () => {
      const newLanguage = localStorage.getItem('language') || 'es-AR'
      setLanguage(newLanguage)
    }
    window.addEventListener('languageChanged', handleLanguageChange)

    return () => {
      window.removeEventListener('languageChanged', handleLanguageChange)
    }
  }, [])

  return loading ? (
    <Loading
      className='loader-container'
      loadingPrimary={'Loading...'}
      loadingSecondary={'The page is loading, please wait a moment'}
    />
  ) : (
    <>
      <CssBaseline />
      <AppGlobalStyles theme={theme} />
      <Admin
        store={sessionStorageStore()}
        theme={theme}
        loading={() => <Loading className='loader-container' />}
        dataProvider={dataProvider}
        authProvider={authProvider}
        i18nProvider={getI18nProvider(language)}
        layout={LayoutTopNav}
        dashboard={Dashboard}
        loginPage={LoginCustom}
      >
        {getResourcesWithPermissions}

        <CustomRoutes noLayout>
          <Route exact path='/recover' element={<LoginCustom recover />} />
        </CustomRoutes>

        <CustomRoutes>
          <Route exact path='/my-devices' element={<MyDevices />} />
        </CustomRoutes> 
      </Admin>
    </>
  )
}

export default App
